import { render, staticRenderFns } from "./EmployeesAssignmentTripPage.vue?vue&type=template&id=2b50c462&scoped=true&"
import script from "./EmployeesAssignmentTripPage.vue?vue&type=script&lang=js&"
export * from "./EmployeesAssignmentTripPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50c462",
  null
  
)

export default component.exports